import { createContext } from 'react';

export const FavoritesContext = createContext<{
  favorites: string[];
  toggleFavorite(id: string): void;
  isFavoriteFilterActive: boolean;
  toggleFavoriteFilter(isEnabled: boolean): void;
}>({
  favorites: [],
  toggleFavorite: () => {},
  isFavoriteFilterActive: false,
  toggleFavoriteFilter: () => {},
});
